import { useParentPostMessage } from '@yes.technology/react-toolkit'
import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import {
  CANCEL_SELECT_AND_LINK_POST_MESSAGE_TYPE,
  SELECT_AND_LINK_PARAM,
  SELECT_AND_LINK_POST_MESSAGE_TYPE
} from './SelectAndLink.constants'
import { SelectAndLinkValue } from './SelectAndLink.types'

export function useSelectAndLinkIframeBridge() {
  const [searchParams] = useSearchParams()

  const { postMessage } = useParentPostMessage()

  const shouldRenderSelectAndLink = useMemo(() => {
    return searchParams.has(SELECT_AND_LINK_PARAM)
  }, [searchParams])

  const selectAndLink = useCallback(
    (values: SelectAndLinkValue[]) => {
      postMessage({
        type: SELECT_AND_LINK_POST_MESSAGE_TYPE,
        values
      })
    },
    [postMessage]
  )

  const cancelSelectAndLink = useCallback(() => {
    postMessage({
      type: CANCEL_SELECT_AND_LINK_POST_MESSAGE_TYPE
    })
  }, [postMessage])

  return {
    shouldRenderSelectAndLink,
    selectAndLink,
    cancelSelectAndLink
  }
}
